import { useEffect, useState } from "react";
import MaterialIcon from "@common/components/MaterialIcon";
import { coverFor } from "./covers";

/** A game's box art; a placeholder of the same shape while it loads or when there is none. */
export default function Cover({ name, className }: { name: string; className: string }) {
  // undefined while looking it up, null when there is none.
  const [src, setSrc] = useState<string | null | undefined>(undefined);
  useEffect(() => {
    let live = true;
    setSrc(undefined);
    coverFor(name).then((url) => live && setSrc(url));
    return () => {
      live = false;
    };
  }, [name]);
  if (src) return <img src={src} alt="" className={className} loading="lazy" onError={() => setSrc(null)} />;
  return (
    <span className={`${className} cover-blank`} aria-hidden="true">
      {src === null && <MaterialIcon name="videogame_asset" />}
    </span>
  );
}
